var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_document",
            title:
              _vm.formContext.data.name || "Neues firmenspezifisches Dokument",
          },
          on: {
            "cancel-form": _vm.handleCancel,
            save: _vm.saveFirmSpecificDocument,
          },
        },
        [
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Bezeichnung des Dokuments",
                  property: "name",
                  required: "",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3 align-content-end",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: _vm.shareWithFirmGroupLabel,
                  property: "shareWithFirmGroup",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3 align-content-end",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: _vm.shareWithFirmAssociationLabel,
                  property: "shareWithFirmAssociation",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Erlaubte Dateikategorien",
                  property: "allowedFileCategories",
                  tooltip:
                    "wenn keine Auswahl getroffen wurde, werden alle Dateikategorien dargestellt",
                  type: "multiselectsearchable",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "9" } },
                [
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Text",
                      property: "htmlTemplate",
                      type: "ckeditor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Betreff / Thema",
                      property: "subject",
                      required: "",
                      type: "autogrowtextarea",
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "E-Mail Empfänger Mailadresse",
                      placeholder: _vm.mailRecipientEmailPlaceholder,
                      property: "mailRecipientEmail",
                      tooltip: "Platzhalter möglich",
                      type: "text",
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "E-Mail Empfänger Name",
                      placeholder: _vm.mailRecipientNamePlaceholder,
                      property: "mailRecipientName",
                      tooltip: "Platzhalter möglich",
                      type: "text",
                    },
                  }),
                  _vm._v(" "),
                  _vm.displayAdditionalMailRecipientsHeader
                    ? _c("h3", [
                        _vm._v(
                          "\n                Zusätzliche Empfänger\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(
                    _vm.formContext.form.getSubformIdentifiers(),
                    function (subformIdentifier) {
                      return _c(
                        "b-card",
                        {
                          key: subformIdentifier,
                          staticClass: "info-card mb-4",
                        },
                        [
                          _vm.formContext.isInEditMode
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "float-right",
                                  attrs: {
                                    size: "sm",
                                    title: "Empfänger entfernen",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeAdditionalMailRecipient(
                                        subformIdentifier
                                      )
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "inticon-close" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("csp-desktop-info-card-element", {
                                staticClass: "col-3 mb-4",
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "Typ",
                                  property: "type",
                                  required: "",
                                  "subform-identifier": subformIdentifier,
                                  type: "autocomplete",
                                },
                              }),
                              _vm._v(" "),
                              _c("csp-desktop-info-card-element", {
                                staticClass: "col-9 mb-4",
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "Name",
                                  property: "name",
                                  "subform-identifier": subformIdentifier,
                                  tooltip: "Platzhalter möglich",
                                  type: "text",
                                },
                              }),
                              _vm._v(" "),
                              _c("csp-desktop-info-card-element", {
                                staticClass: "col-9 mb-0",
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "E-Mail Adresse",
                                  property: "mail",
                                  required: "",
                                  "subform-identifier": subformIdentifier,
                                  tooltip: "Platzhalter möglich",
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  _vm._v(" "),
                  _vm.formContext.isInEditMode
                    ? _c(
                        "div",
                        {
                          staticClass: "mb-4",
                          on: { click: _vm.addAdditionalMailRecipient },
                        },
                        [_c("b-button", [_vm._v("Empfänger hinzufügen")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Signatur bereits in Template enthalten",
                      property: "hasSignatureIncluded",
                      type: "checkbox",
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Vermerkthema",
                      "options-loader": _vm.loadOptions("noteCodeCategories"),
                      property: "noteCodeCategory",
                      type: "autocomplete",
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      dependencies: ["noteCodeCategory"],
                      "form-context": _vm.formContext,
                      label: "Vermerk",
                      "options-loader": _vm.loadOptions("noteCodesRecordless", {
                        noteCodeCategoryId: _vm.noteCodeCategory,
                      }),
                      property: "noteCode",
                      type: "autocomplete",
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Nachhalte-E-Mail Vorlage",
                      "options-loader": _vm.loadFollowUpDocumentOptions,
                      property: "followUpDocument",
                      type: "autocomplete",
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Nachhalte-E-Mail nach (Tage)",
                      property: "followUpDays",
                      type: "text",
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Dokument ist verfügbar für Schadenarten",
                      property: "allowedClaimTypes",
                      tooltip:
                        "Wenn keine Schadenarten ausgewählt sind, steht das Dokument uneingeschränkt für alle Schadenarten zur Verfügung",
                      type: "multiselectsearchable",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "4" } }),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "4" } }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showActionButtons
            ? _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", { attrs: { cols: "6" } }),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { cols: "6" } },
                    [
                      _vm.showDeleteButton
                        ? _c(
                            "b-button",
                            { on: { click: _vm.openDeleteConfirmationModal } },
                            [
                              _vm._v(
                                "\n                Dokument löschen\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: { "cancel-title": "Abbrechen", title: "Dokument löschen" },
              on: { ok: _vm.deleteFirmSpecificDocument },
              model: {
                value: _vm.isDeleteConfirmationModalOpen,
                callback: function ($$v) {
                  _vm.isDeleteConfirmationModalOpen = $$v
                },
                expression: "isDeleteConfirmationModalOpen",
              },
            },
            [
              _vm._v(
                "\n        Wollen Sie das Dokument wirklich löschen?\n    "
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }